import { formatPhone, phoneErrorCode } from 'helper/prospectPhone';
import { DEFAULT_PROSPECT_SOURCE } from 'helper/prospectOptions';

const DIRECTORY_FIELDS = [
  'reasonSocial',
  'siret',
  'legalForm',
  'codeApe',
  'idcc',
  'staff',
  'activity',
];

export const emptyProspectForm = () => ({
  name: '',
  address: '',
  phone: '',
  contacts: [],
  sector: '',
  source: DEFAULT_PROSPECT_SOURCE,
  // The commercial in charge: the caller when a commercial, else chosen.
  commercialId: '',
  today: true,
});

export const isProspectFormValid = ({ company, form }) => {
  if (!company || company.followed) return false;
  if (!String(form.name ?? '').trim()) return false;
  if (phoneErrorCode(form.phone)) return false;
  return (form.contacts ?? []).every(
    (contact) =>
      !String(contact.phone ?? '').trim() || !phoneErrorCode(contact.phone),
  );
};

const buildAddress = (company, rawAddress) => {
  const address = String(rawAddress ?? '').trim();
  if (company.location && address === String(company.address ?? '').trim()) {
    return company.location;
  }
  if (!address) return null;
  const postcode = address.match(/\b\d{5}\b/)?.[0];
  const commaIndex = address.indexOf(',');
  const result = {
    street: (commaIndex === -1 ? address : address.slice(0, commaIndex)).trim(),
  };
  if (postcode) {
    result.postcode = postcode;
    result.department = postcode.startsWith('97')
      ? postcode.slice(0, 3)
      : postcode.slice(0, 2);
  }
  const city =
    company.city ||
    (postcode ? address.slice(address.indexOf(postcode) + 5).trim() : '');
  if (city) result.city = city;
  return result;
};

export const buildProspectPayload = ({ company, form }) => {
  const fields = {
    name: String(form.name ?? '').trim() || company.name,
  };
  if (!company.manual) {
    DIRECTORY_FIELDS.forEach((key) => {
      // A staff of 0 (INSEE band '00') is a real value.
      if (
        company[key] !== undefined &&
        company[key] !== null &&
        company[key] !== ''
      ) {
        fields[key] = company[key];
      }
    });
    if (company.leader) fields.leader = company.leader;
  }
  const address = buildAddress(company, form.address);
  if (address) fields.address = address;
  if (form.sector) fields.sector = form.sector;
  fields.source = form.source;
  if (form.commercialId) fields.commercialId = form.commercialId;
  fields.phone = formatPhone(form.phone);
  fields.contacts = (form.contacts ?? [])
    .filter(
      (contact) =>
        String(contact.name ?? '').trim() || String(contact.phone ?? '').trim(),
    )
    .map((contact) => ({
      name: String(contact.name ?? '').trim(),
      position: String(contact.position ?? '').trim(),
      phone: String(contact.phone ?? '').trim()
        ? formatPhone(contact.phone)
        : '',
      email: String(contact.email ?? '').trim(),
    }));
  return { fields, addToday: Boolean(form.today) };
};
